import { render, staticRenderFns } from "./startTem.vue?vue&type=template&id=3a5d297e&"
import script from "./startTem.vue?vue&type=script&lang=js&"
export * from "./startTem.vue?vue&type=script&lang=js&"
import style0 from "./startTem.vue?vue&type=style&index=0&id=3a5d297e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports